type InlineAdSlotSchema = {
  attribs: InlineAdSlotSchemaAttributes;
  type: typeof InlineAdSlotSchemaType;
};

type InlineAdSlotSchemaAttributes = {
  infiniteAdsAfterNumber?: string;
  tag: string;
};

export const InlineAdSlotSchemaType = "inline-ad-slot";

export type InlineAdSlotSchemaWithRow = InlineAdSlotSchema & {
  row: number;
};

export function defineInlineAdSlotSchema(options: {
  infiniteAdsAfterNumber?: string;
  row: number;
  tag: string;
}): InlineAdSlotSchemaWithRow {
  const { infiniteAdsAfterNumber, row, tag } = options;
  return {
    attribs: {
      infiniteAdsAfterNumber,
      tag,
    },
    row,
    type: InlineAdSlotSchemaType,
  };
}

export function isInlineAdSlotSchema(node: SchemaNode): node is InlineAdSlotSchema {
  return node.type === InlineAdSlotSchemaType;
}
